import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useUser } from '../../utils/userContext';
import { ToastContainer, toast } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import useConfiguration from '../../utils/ConfigurationContext';
import Select from 'react-select';

const WelcomeKit = () => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("Choose file");
  const [docFile, setDocFile] = useState(null);
  const [docFileName, setDocFileName] = useState("Choose file");
  const [verificationFile, setVerificationFile] = useState(null);
  const [verificationFileName, setVerificationFileName] = useState("Choose file");
  const [showModal, setShowModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [verificationValid, setVerificationValid] = useState(true);
  const { user } = useUser();
  const [offerLetterValid, setOfferLetterValid] = useState(true);
  const handleErrors = useHandleErrors();
  const empId = localStorage.getItem("EmployeeId");
  const Skipped = localStorage.getItem("Skipped");
  const config = useConfiguration();
  const initialLeaveDetails = {};
  config?.leaveManagement?.holidayTypes.forEach(type => {
    initialLeaveDetails[type] = { hours: 0, reason: '' };
  });
  const [leaveDetails, setLeaveDetails] = useState(initialLeaveDetails);
  const token = localStorage.getItem("token");
  const [monthlyLeaves, setMonthlyLeaves] = useState(null);
  const ClearIndicator = () => null;

  const initialState = {
    offerLetter: false,
    biometricAccess: false,
    assetConfirmation: false,
    employeeDocuments: false,
    welcomeKit: false,
    leavesAssigned: false,
    mothlyLeaves: false,
    employeeVerification: false,
    offerLetterFile: null,
    employeeVerificationFile: null,
    employeeDocumentsFile: null,
    ActiveFlag: "Y",
    UpdatedBy: user?.FirstName,
  };
  const [formData, setFormData] = useState(initialState);
  const navigate = useNavigate();

  useEffect(() => {
    const preloading = document.getElementById('preloading');
    setTimeout(() => {
      if (preloading) {
        preloading.style.display = 'none';
      }
    }, 400);
  }, []);

  const handleChange = (e, type, field) => {
    setLeaveDetails({
      ...leaveDetails,
      [type]: {
        ...leaveDetails[type],
        [field]: e.target.value,
      },
    });
  };

  const handleToggleChange = (event) => {
    const { name, checked } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked,
    }));

    if (name === 'leavesAssigned' && checked) {
      setShowAssignModal(true);
    } else if (name === 'leavesAssigned' && !checked) {
      setShowAssignModal(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (allowedTypes.includes(selectedFile.type)) {
        setFile(selectedFile);
        setFileName(selectedFile.name);
        setOfferLetterValid(true);
      } else {
        toast.error("Only .doc and .pdf files are allowed.", {
          position: toast.POSITION.TOP_CENTER,
        });
        setOfferLetterValid(false);
      }
    }
  };

  const handleVerificationFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (allowedTypes.includes(selectedFile.type)) {
        setVerificationFile(selectedFile);
        setVerificationFileName(selectedFile.name);
        setVerificationValid(true);
      } else {
        toast.error("Only .doc and .pdf files are allowed.", {
          position: toast.POSITION.TOP_CENTER,
        });
        setVerificationValid(false);
      }
    }
  };

  const handleIdChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (allowedTypes.includes(selectedFile.type)) {
        setDocFile(selectedFile);
        setDocFileName(selectedFile.name);
      } else {
        toast.error("Only .doc and .pdf files are allowed.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    const payload = new FormData();
    payload.append('EmployeeId', empId);
    payload.append('BiometricAccess', formData.biometricAccess);
    payload.append('AssetHandoverConfirmation', formData.assetConfirmation);
    payload.append('WelcomeKit', formData.welcomeKit);
    payload.append('LeaveCredit', formData.mothlyLeaves);
    payload.append('EmployeeVerification', formData.employeeVerification);
    if (file) {
      payload.append('OfferLetter', file);
    }
    if (verificationFile) {
      payload.append('EmployeeVerificationFile', verificationFile);
    }
    if (docFile) {
      payload.append('EmployeeDocuments', docFile);
    }
    payload.append('ActiveFlag', "Y");
    payload.append('UpdatedBy', user?.FirstName);

    try {
      const path = "/welcomeKit";
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.put(URL,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        setShowModal(true);
        setFormData(initialState);
      } else {
        handleErrors(response);
      }
    } catch (error) {
      if (error.response) {
        handleErrors(error.response);
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLeavesSubmit = async () => {
    setLoading(true);
    const leaveBalance = Object.entries(leaveDetails).map(([type, details]) => ({
      LeaveType: type,
      NoOfLeaves: details.hours ? details.hours : "0",
      Reason: details.reason ? details.reason : ""
    }));

    const payload = {
      EmployeeId: empId,
      LeaveBalance: leaveBalance.length > 0 ? leaveBalance : config?.leaveManagement?.holidayTypes?.map(type => ({
        LeaveType: type,
        NoOfLeaves: "0",
        Reason: ""
      })) || [],
      MonthlyLeaveBalance: monthlyLeaves ? monthlyLeaves : null,
      UpdatedBy: user?.FirstName
    };

    try {
      const path = "/insertLeaveBalance";
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.post(URL, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        toast.success("Leave Balances Added Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
        setShowAssignModal(false);
      } else {
        handleErrors(response);
      }
    } catch (error) {
      if (error.response) {
        handleErrors(error.response);
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    localStorage.removeItem("EmployeeId");
    localStorage.removeItem("EmployeeName");
    localStorage.removeItem("OfficialEmail");
    navigate('/home');
  };

  const handleCloseLeaveModal = () => {
    setShowAssignModal(false);
    if (formData.leavesAssigned && Object.entries(leaveDetails).length === 0) {
      setFormData((prevData) => ({
        ...prevData,
        leavesAssigned: false,
      }));
    }
  };

  const handleAssignModal = () => {
    if (formData.leavesAssigned && Object.entries(leaveDetails).length === 0) {
      setFormData((prevData) => ({
        ...prevData,
        leavesAssigned: false,
      }));
    }
    setShowAssignModal(false);
  };

  const handleReset = () => {
    setFormData(initialState);
    setFile(null);
    setVerificationFile(null);
    setDocFile(null);
    setFileName("Choose file");
    setVerificationFileName("Choose file");
    setDocFileName("Choose file");
  };

  const handlePrevious = () => {
    localStorage.removeItem("Skipped");
    navigate("/assignasset");
  };

  return (
    <div>
      {loading && (
        <div id="preloading">
          <span className="loader"></span>
        </div>
      )}
      <ToastContainer />
      <div className="content-page">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col">
              <h3 className="title mb-2">Onboard Employee</h3>
            </div>
            <div className="col-auto">
              <Link
                to={'/Employees'}
                data-extra-toggle="tab"
                data-target="#organisation-pan"
                className="btn btn-primary mt-lg-0 mt-4"
              >
                <i className="ri-user-star-line"></i> View All Employees
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-1">
              <div className="circle-tab-wrapper">
                <ul className="nav nav-tabs circle-tab" role="tablist">
                  <li className="nav-item step-done">
                    <a
                      className="nav-link"
                      title="Employee Information"
                      rel="tooltip"
                      role="tab"
                    >
                      <i className="ri-user-shared-line"></i>
                    </a>
                  </li>
                  <li className="nav-item step-done">
                    <a
                      className="nav-link"
                      title="Assign Asset"
                      rel="tooltip"
                      role="tab"
                    >
                      <i className="ri-list-check-3"></i>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      data-toggle="tab"
                      to="/welcomekit"
                      title="Welcome Kit?"
                      rel="tooltip"
                      role="tab"
                    >
                      <i className="ri-shapes-line"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-11">
              <div className="tab-pane" id="welcome-kit" role="tabpanel">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="row">
                          <div className="col">
                            <h5 className="title mt-1 mb-0">Welcome Kit</h5>
                          </div>
                        </div>
                        <div className="row align-items-center justify-content-center mt-4">
                          <div className="col-sm-12 col-md-8 col-lg-7">
                            <div className="container-fluid row-rounded">
                              <div className="row px-2 py-0">
                                <div className="input-group mb-0">
                                  <input style={{ borderRadius: "20px" }}
                                    type="search"
                                    className="form-control"
                                    value={empId}
                                    readOnly
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="container-fluid row-rounded">
                              <div className="row">
                                <div className="col-auto">
                                  <div className="circle-icon-box">
                                    <i className="ri-article-line"></i>
                                  </div>
                                </div>
                                <div className="col">
                                  Offer Letter{' '}
                                  <small className="form-text text-muted">
                                    Upload if yes
                                  </small>
                                </div>
                                <div className="col-2">
                                  <div className="button-cover">
                                    <div className="btn-switch button r">
                                      <input
                                        type='checkbox'
                                        className="checkbox"
                                        name="offerLetter"
                                        accept=".pdf,.doc,application/msword"
                                        checked={formData.offerLetter}
                                        onChange={handleToggleChange}
                                      />
                                      <div className="knobs"></div>
                                      <div className="layer"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {formData.offerLetter && (
                              <div className="row">
                                <div className="form-group col-md-12">
                                  <div className="input-group">
                                    <div className="custom-file">
                                      <input
                                        type="file"
                                        className="custom-file-input"
                                        id="offerLetterFile"
                                        name="offerLetterFile"
                                        accept=".pdf,.doc,application/msword"
                                        onChange={handleFileChange}
                                      />
                                      <label
                                        className="custom-file-label"
                                        htmlFor="offerLetterFile"
                                      >
                                        {fileName}
                                      </label>
                                      {!offerLetterValid && (
                                        <div className="invalid-feedback d-block">
                                          Only .doc and .pdf files are allowed.
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="container-fluid row-rounded">
                              <div className="row">
                                <div className="col-auto">
                                  <div className="circle-icon-box">
                                    <i className="ri-file-check-line"></i>
                                  </div>
                                </div>
                                <div className="col">
                                  Employee Verification{' '}
                                  <small className="form-text text-muted">
                                    Upload if yes
                                  </small>
                                </div>
                                <div className="col-2">
                                  <div className="button-cover">
                                    <div className="btn-switch button r">
                                      <input
                                        type='checkbox'
                                        className="checkbox"
                                        name="employeeVerification"
                                        accept=".pdf,.doc,application/msword"
                                        checked={formData.employeeVerification}
                                        onChange={handleToggleChange}
                                      />
                                      <div className="knobs"></div>
                                      <div className="layer"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {formData.employeeVerification && (
                              <div className="row">
                                <div className="form-group col-md-12">
                                  <div className="input-group">
                                    <div className="custom-file">
                                      <input
                                        type="file"
                                        className="custom-file-input"
                                        id="employeeVerificationFile"
                                        name="employeeVerificationFile"
                                        accept=".pdf,.doc,application/msword"
                                        onChange={handleVerificationFileChange}
                                      />
                                      <label
                                        className="custom-file-label"
                                        htmlFor="employeeVerificationFile"
                                      >
                                        {verificationFileName}
                                      </label>
                                      {!verificationValid && (
                                        <div className="invalid-feedback d-block">
                                          Only .doc and .pdf files are allowed.
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="container-fluid row-rounded">
                              <div className="row">
                                <div className="col-auto">
                                  <div className="circle-icon-box">
                                    <i className="ri-fingerprint-line"></i>
                                  </div>
                                </div>
                                <div className="col">
                                  Biometric Access{" "}
                                  <small className="form-text text-muted">
                                    Captured successfully?
                                  </small>
                                </div>
                                <div className="col-2">
                                  <div className="button-cover">
                                    <div className="btn-switch button r">
                                      <input
                                        type="checkbox"
                                        className="checkbox"
                                        name="biometricAccess"
                                        checked={formData.biometricAccess}
                                        onChange={handleToggleChange}
                                      />
                                      <div className="knobs"></div>
                                      <div className="layer"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="container-fluid row-rounded">
                              <div className="row">
                                <div className="col-auto">
                                  <div className="circle-icon-box">
                                    <i className="ri-file-list-3-fill"></i>
                                  </div>
                                </div>
                                <div className="col">
                                  Leaves{" "}
                                  <small className="form-text text-muted">
                                    Assigned?
                                  </small>
                                </div>
                                <div className="col-2">
                                  <div className="button-cover">
                                    <div className="btn-switch button r">
                                      <input
                                        type="checkbox"
                                        className="checkbox"
                                        name="leavesAssigned"
                                        checked={formData.leavesAssigned}
                                        onChange={handleToggleChange}
                                      />
                                      <div className="knobs"></div>
                                      <div className="layer"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="container-fluid row-rounded">
                              <div className="row">
                                <div className="col-auto">
                                  <div className="circle-icon-box">
                                    <i className="ri-hand-coin-line"></i>
                                  </div>
                                </div>
                                <div className="col">
                                  Asset Confirmation{" "}
                                  <small className="form-text text-muted">
                                    Handed over?
                                  </small>
                                </div>
                                <div className="col-2">
                                  <div className="button-cover">
                                    <div className="btn-switch button r">
                                      <input
                                        type="checkbox"
                                        className="checkbox"
                                        name="assetConfirmation"
                                        checked={formData.assetConfirmation}
                                        onChange={handleToggleChange}
                                      />
                                      <div className="knobs"></div>
                                      <div className="layer"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="container-fluid row-rounded">
                              <div className="row">
                                <div className="col-auto">
                                  <div className="circle-icon-box">
                                    <i className="ri-file-text-line"></i>
                                  </div>
                                </div>
                                <div className="col">
                                  Employee Documents{" "}
                                  <small className="form-text text-muted">
                                    Upload if yes
                                  </small>
                                </div>
                                <div className="col-2">
                                  <div className="button-cover">
                                    <div className="btn-switch button r">
                                      <input
                                        type="checkbox"
                                        className="checkbox"
                                        name="employeeDocuments"
                                        accept=".pdf,.doc,application/msword"
                                        checked={formData.employeeDocuments}
                                        onChange={handleToggleChange}
                                      />
                                      <div className="knobs"></div>
                                      <div className="layer"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {formData.employeeDocuments && (
                              <div className="row">
                                <div className="form-group col-md-12">
                                  <div className="input-group">
                                    <div className="custom-file">
                                      <input
                                        type="file"
                                        className="custom-file-input"
                                        id="employeeDocumentsFile"
                                        name="employeeDocumentsFile"
                                        accept=".pdf,.doc,application/msword"
                                        onChange={handleIdChange}
                                      />
                                      <label
                                        className="custom-file-label"
                                        htmlFor="employeeDocumentsFile"
                                      >
                                        {docFileName}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="container-fluid row-rounded">
                              <div className="row">
                                <div className="col-auto">
                                  <div className="circle-icon-box">
                                    <i className="ri-shapes-line"></i>
                                  </div>
                                </div>
                                <div className="col">
                                  Welcome Kit{" "}
                                  <small className="form-text text-muted">
                                    All distributed?
                                  </small>
                                </div>
                                <div className="col-2">
                                  <div className="button-cover">
                                    <div className="btn-switch button r">
                                      <input
                                        type="checkbox"
                                        className="checkbox"
                                        name="welcomeKit"
                                        checked={formData.welcomeKit}
                                        onChange={handleToggleChange}
                                      />
                                      <div className="knobs"></div>
                                      <div className="layer"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row mt-4">
                              <div className="col text-center">
                                {Skipped === "Skipped" && (
                                  <button
                                    className="btn btn-light mr-2"
                                    type="button"
                                    onClick={handlePrevious}
                                  >
                                    <i className="ri-arrow-left-circle-line"></i> Previous
                                  </button>
                                )}
                                <button
                                  className="btn btn-light mr-2"
                                  type="button"
                                  onClick={handleReset}
                                  disabled={loading}
                                >
                                  <i className="ri-restart-line mr-1"></i> Reset
                                </button>
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  onClick={handleSubmit}
                                  disabled={loading || !offerLetterValid || !verificationValid}
                                >
                                  Submit <i className="ri-checkbox-circle-line"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {showModal && (
                      <div
                        className="modal fade show d-block"
                        tabIndex="-1"
                        role="dialog"
                        aria-labelledby="successModalLabel"
                        aria-hidden="true"
                      >
                        <div
                          className="modal-dialog modal-sm modal-dialog-centered"
                          role="document"
                        >
                          <div className="modal-content shadow success-modal">
                            <div className="modal-header py-2">
                              <h6
                                className="modal-title"
                                id="successModalLabel"
                              >
                                Success!
                              </h6>
                              <button
                                className="close"
                                type="button"
                                aria-label="Close"
                                onClick={handleCloseModal}
                              >
                                <span aria-hidden="true">
                                  <i className="ri-close-circle-fill font-size-20"></i>
                                </span>
                              </button>
                            </div>
                            <div className="modal-body pb-5">
                              <div className="row">
                                <div className="col-12 text-success text-center">
                                  <i className="ri-checkbox-circle-fill"></i>
                                </div>
                                <div className="col-12 text-center">
                                  Employee {empId} onboarded successfully.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showAssignModal && (
        <Modal show={showAssignModal} onHide={handleAssignModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Assign Leaves</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col">
                <h5 className="title mt-1 mb-0">
                  <span data-toggle="popover" data-html="true" data-content="<div><b>Employee Fullname</b><br>firstname.lastname@email.com<br>Admin</div>">
                  </span>
                  <small>
                    <span>EmployeeId : {empId}</span>
                    <div className="form-group mt-2">
                      <label className="d-block">Add Monthly Leaves</label>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        name="monthlyLeaves"
                        value={{ value: monthlyLeaves, label: monthlyLeaves }}
                        onChange={(selectedOption) => setMonthlyLeaves(selectedOption ? selectedOption.value : null)}
                        options={[
                          { value: "Yes", label: "Yes" },
                          { value: "No", label: "No" },
                        ]}
                        isClearable
                        components={{ ClearIndicator }}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>
                  </small>
                </h5>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-12">
                <Table responsive>
                  <thead className="bg-light">
                    <tr>
                      <th>Leave Type</th>
                      <th className="text-center" width="90">New</th>
                      <th>Reason</th>
                    </tr>
                  </thead>
                  <tbody>
                    {config?.leaveManagement?.holidayTypes?.map(type => (
                      <tr key={type}>
                        <td className="paid-leave">{type}</td>
                        <td>
                          <Form.Control
                            type="text"
                            placeholder="0"
                            value={leaveDetails[type]?.hours || ''}
                            onChange={(e) => handleChange(e, type, 'hours')}
                          />
                        </td>
                        <td>
                          <Form.Control
                            type="text"
                            value={leaveDetails[type]?.reason || ''}
                            onChange={(e) => handleChange(e, type, 'reason')}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-center py-2">
            <Button variant="light" onClick={handleCloseLeaveModal}>Cancel</Button>
            <Button variant="primary" onClick={handleLeavesSubmit}>Submit <i className="ri-checkbox-circle-line"></i></Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default WelcomeKit;